let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lgq4W")).then(() => parcelRequire('gQpn0'));